const pdfjslib=require('pdfjs-dist')

function getPdfJs(){
    return pdfjslib;
}

function init(pfx){
    pfx=pfx || ''

    pdfjslib.GlobalWorkerOptions.workerSrc='https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.13.216/pdf.worker.min.js'
}

module.exports={
    init,
    getPdfJs
}